import React, { Component } from "react";
export class Services extends Component {
  render() {
    return (
      <div id="services" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Our Services</h2>
            <p>
              Just do your job and feel that you are doing a great service to
              society".
            </p>
          </div>
          <div className="row">
            {this.props.data
              ? this.props.data.map((d, i) => (
                  <div
                    key={`${d.name}-${i}`}
                    className="col-md-4 col-sm-6 col-12"
                  >
                    {" "}
                    <img
                      style={{ width: "100%" }}
                      src={require(`../../assets/img/services/${d.img}.jpg`)}
                      alt="service"
                    />
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                      <p>{d.text2}</p>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>
        </div>
      </div>
    );
  }
}

export default Services;
